import { useRef } from "react";

export function useOverlayClose(onClose) {
  const pressStartedInsideContentRef = useRef(false);

  function handleOverlayMouseDown(event) {
    pressStartedInsideContentRef.current = event.target !== event.currentTarget;
  }

  function handleOverlayClick(event) {
    const pressStartedInsideContent = pressStartedInsideContentRef.current;
    pressStartedInsideContentRef.current = false;
    if (event.target !== event.currentTarget) return;
    if (pressStartedInsideContent) return;
    onClose?.();
  }

  return { onMouseDownCapture: handleOverlayMouseDown, onClick: handleOverlayClick };
}
